class ItemAdesaoApiClient {}

export default new ItemAdesaoApiClient()
